import EndedProcessInstanceTableAction from './EndedProcessInstanceTableAction';

export default EndedProcessInstanceTableAction;
